import service from '../../config/axios.config';

export const getObjectiveRelationsByObjective = ({
  objectiveId
}) =>
  service.get(
    `/objective/${objectiveId}/relations`
  );